
import * as types from './types';
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
// Mutations Object for ArtistsCatalog. Use it by importing artists/types.js and calling commit() from  artists/actions.js Action File.
export const recoupableMutations = {
  [types.RecoupableData.SET.ALL] (state, payload) {
    //console.log("payload.all_artists",payload)
    state.recoupableData = payload;
    //state.artistsList=payload.all_artists
  },

  [types.RecoupableList.SET.ALL](state,payload){

    state.recoupableList=payload;

  },



}